const stickyBottomBar = document.querySelector('[data-pdp-sticky-form]');
const stickyBottomAtc = document.getElementById('AddToCart-sticky');

function handleScroll() {
  const scrollPosition = window.scrollY || window.pageYOffset;
  const zoomLevel = window.devicePixelRatio * 100;
  let scrollPositionThreshold = 900;

  if (zoomLevel >= 220) {
    scrollPositionThreshold = 1200;
  }

  if (scrollPosition > scrollPositionThreshold) {
    stickyBottomBar.classList.add('active');
    if (stickyBottomAtc) stickyBottomAtc.setAttribute('tabindex', '0');
  } else {
    stickyBottomBar.classList.remove('active');
    if (stickyBottomAtc) stickyBottomAtc.setAttribute('tabindex', '-1');
  }
}
window.addEventListener('scroll', handleScroll);

function announceToScreenReader(message) {
  const announcement = document.getElementById('sr-announcement');
  if (announcement) {
    announcement.textContent = message;
  }
}

function handleViewMoreClick() {
  const productsList = document.querySelector('.suggested-products-cover');
  const elements = document.querySelectorAll('.suggested_product_wrapper:nth-child(n+4)');
  const totalItems = productsList ? productsList.getAttribute('data-total-items') : 0;
  const productListTitle = productsList ? productsList.getAttribute('data-product-list-title') : 'Product List';

  elements.forEach(function(element) {
    element.style.display = "flex";
  });
  viewLessButton.parentNode.style.display = "flex";
  viewMoreButton.parentNode.style.display = "none";
  
  if (productsList) {
    productsList.setAttribute('aria-expanded', 'true');
    productsList.setAttribute('data-visible-items', totalItems);
  }

  viewMoreButton.setAttribute('aria-expanded', 'true');
  viewLessButton.setAttribute('aria-expanded', 'true');

  announceToScreenReader(`${productListTitle} expanded. Showing all ${totalItems}.`);

  if (elements.length > 0) {
    setTimeout(() => {
      const firstNewItem = elements[0];
      const focusableElement = firstNewItem.querySelector('a, button, input, select, [tabindex="0"]');
      if (focusableElement) {
        focusableElement.focus();
      } else {
        firstNewItem.setAttribute('tabindex', '-1');
        firstNewItem.focus();
      }
    }, 100);
  }
}

function handleViewLessClick() {
  const productsList = document.querySelector('.suggested-products-cover');
  const elements = document.querySelectorAll('.suggested_product_wrapper:nth-child(n+4)');
  const productListTitle = productsList ? productsList.getAttribute('data-product-list-title') : 'Product List';

  elements.forEach(function(element) {
    element.style.display = "none";
  });
  viewLessButton.parentNode.style.display = "none";
  viewMoreButton.parentNode.style.display = "flex";

  if (productsList) {
    productsList.setAttribute('aria-expanded', 'false');
    productsList.setAttribute('data-visible-items', '3');
  }
  
  // Update button ARIA states
  viewMoreButton.setAttribute('aria-expanded', 'false');
  viewLessButton.setAttribute('aria-expanded', 'false');
  
  // Announce to screen readers
  const totalItems = productsList ? productsList.getAttribute('data-total-items') : 0;
  announceToScreenReader(`${productListTitle} collapsed. Showing 3 of ${totalItems}.`);
  
  // Return focus to the "View More" button for better navigation
  setTimeout(() => {
    viewMoreButton.focus();
  }, 100);
}

var viewLessButton = document.querySelector('[data-view-less]');
if (viewLessButton) {
  viewLessButton.addEventListener('click', handleViewLessClick);

  viewLessButton.addEventListener('keydown', (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleViewLessClick();
    }
  });
}

var viewMoreButton = document.querySelector('[data-view-more]');
if (viewMoreButton) {
  viewMoreButton.addEventListener('click', handleViewMoreClick);

  viewMoreButton.addEventListener('keydown', (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleViewMoreClick();
    }
  });
}